export const homePaths  = {
    home: '/',
    about: '/about',
    contact: '/contact',
    privacy: '/privacy',
    terms: '/terms',
};